import * as back from '~/components/layouts/Navigation/BreadcrumbContainer/functional/backLinks';
import { listBreadcrumb } from '~/components/layouts/Navigation/BreadcrumbContainer/functional/generators';
import * as match from '~/components/layouts/Navigation/BreadcrumbContainer/functional/matchers';
import type { RouteRule } from '~/components/layouts/Navigation/BreadcrumbContainer/functional/types';

export const aiRules: RouteRule[] = [
  {
    match: match.startsWith('/ai/policy-handbook'),
    generate: listBreadcrumb('AI', '/ai', 'Policy handbook', '/ai/policy-handbook'),
    backLink: back.goBack,
    priority: 100,
  },
];
